'use strict';

import moment from 'moment';

/**
 * moment functions and filters
 *
 * NOTE:
 *   - dateNumber = hundreds of seconds - need to convert to datetime
 *   - all are assumed to be UTC = 0
 *   - for comparison > convert local now to UTC = 0
 */

/**
 * TODO the conversion of dates is really ugly - excessive function calls
 */

/**
 * Convert date from server - stored as UTC=0
 * @param  {string|number}  date  - date value
 * @param  {bolean} isEnd         - parse end dates (hour 0 of next day)
 * @return {object}               - moment object for provided date
 *
 * NOTE: if date is string, PREVIOUSLY (neo4j) assumed to be already parsed
 */
function parseUTCDate(date, isEnd) {
  var utcM = moment(date).utcOffset(0);
  if(isEnd) { utcM.subtract(1, 'day');}
  return moment(utcM.format('YYYY-MM-DD'));
}

function parseUTCRange(obj) {
  if(!obj.parsedUTC) {
    obj.start = obj.start ? parseUTCDate(obj.start) : null;
    obj.end = obj.end ? parseUTCDate(obj.end, true) : null;
    obj.parsedUTC = true;
  }
}

/**
 * Get the date based on form date
 * @param  {Object} formDate date object used on form
 * @param  {boolean} isEnd   parse end dates (stored as hour 0 of the next day)
 * @return {Number}          Date Number (in hundreds of seconds)
 * Note: end dates are parsed on the server as well, added day for display only
 *       server request should not include additional day
 */
function getDatePropString(date) {
  if(typeof date === 'number') {
    date = moment(date);
    return date.format('YYYY-MM-DD');
  }
  return moment(date).format('YYYY-MM-DD');
}

////////////////////////////////////////////////////////////////////////////
///  Service
////////////////////////////////////////////////////////////////////////////

export function DatetimeSvc() {
  this.parseUTCDate = parseUTCDate;
  this.parseUTCRange = parseUTCRange;
  this.dateToString = dateToString;
  this.endDateToString = endDateToString;
  this.getDatePropString = getDatePropString;
  this.rangeToString = rangeToString;

  /**
   * Set form date range used in datepicker (based on user's timezone)
   * @param  {Object} obj instance with start/end properties
   * @return {Object}     updated instance with startForm/endForm
   */
  this.getFormDateRange = function(obj) {
    parseUTCRange(obj);
    if(obj.start) {
      var formStart = moment(obj.start);
      obj.start = formStart.format('YYYY-MM-DD');
      obj.formStart = new Date(formStart);
    }
    if(obj.end) {
      var formEnd = moment(obj.end);
      obj.end = formEnd.format('YYYY-MM-DD');
      obj.formEnd = new Date(formEnd);
    }
    return obj;
  };

  /**
   * Set object date range (start/end) based on form dates
   * @param  {Object} obj instance with startForm/endForm properties
   * @return {Object}     updated instance with start/end properties as strings
   */
  this.setDatesBasedOnForm = function(obj) {
    if(obj.delete) {
      delete obj.start;
      delete obj.end;
    } else {
      obj.start = obj.formStart ? getDatePropString(obj.formStart) : null;
      obj.end = obj.formEnd ? getDatePropString(obj.formEnd) : null;
    }
    return obj;
  };

  return this;
}

////////////////////////////////////////////////////////////////////////////
///  Filters
////////////////////////////////////////////////////////////////////////////
export function dateToString(date, outputFormat, isEnd) {
  if(typeof date === 'undefined' || date === null) { return null; }
  outputFormat = outputFormat || 'M/D/YY';
  // dates stored in hundreds of seconds
  var m = moment.utc(date);
  if(isEnd) { m.subtract(1, 'day'); }
  return m.isValid() ? m.format(outputFormat) : null;
}

export function endDateToString(date, outputFormat) {
  return dateToString(date, outputFormat, true);
}

export function dateToStringFilter() {
  return dateToString;
}

/**
 * NOTE: date range from server is [start,end), but displayed as [start, end-1]
 */
function rangeToString(dateObj, outputFormat) {
  outputFormat = outputFormat || 'M/D/YY';

  parseUTCRange(dateObj);
  start = dateObj.start || 0;
  var start = moment(start);

  var noEnd = !dateObj.end;
  // default end set to 1/1/3000 when null;
  // 325036800 = moment('3000-01-01').utcOffset(0, true).valueOf() / 100000
  end = dateObj.end || moment(32503680000000);
  // convert values to moment objects
  var endCompare = moment(end); // don't set date forward to comparison
  var end = moment(end);

  // compare to today - range is [start,end)
  var today = moment();
  var relativeText = '';
  if(today.isAfter(endCompare.add(1, 'day'))) {
    relativeText = 'Past';
  } else if(today.isSameOrAfter(start) && today.isSameOrBefore(endCompare)) {
    relativeText = 'Current';
    if(today.isSame(end, 'day')) {
      relativeText += ' - Ends Today';
    }
  } else {
    relativeText = 'Future';
  }

  // convert to text
  start = start.format(outputFormat);
  end = end.format(outputFormat);
  if(noEnd) { end = 'Future'; }
  return start + ' - ' + end + ' (' + relativeText + ')';
}


export function rangeToStringFilter() {
  return rangeToString;
}
